import {remoteStream} from '@stream'
import {useEventBus} from '@vueuse/core'

export const useStreamCallback = () => {
  useEventBus('strategy:stream:video').on((event: any) => {
    const {stream} = event
    remoteStream.video.value = stream
  })

  useEventBus('strategy:stream:audio').on((event: any) => {
    const {stream} = event
    remoteStream.audio.value = [...remoteStream.audio.value, stream]
  })
}
